// 个人信息页
import React, { useState, useEffect } from 'react';
import { Button, Layout, Avatar, message } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import PageTopbar from '@/components/pagetopbar';
import usePageBack from '@/utils/usePageBack';
import { useNavigate, useLocation, Navigate, Link } from 'react-router-dom';
import './index.scss';
import EditAllModal from './components/EditAllModal';
import EditNicknameModal from './components/EditNicknameModal';
import EditAvatarModal from './components/EditAvatarModal';
import EditGenderModal from './components/EditGenderModal';
import { useSelector } from 'react-redux';
import SchoolEditor from '@/components/schooleditor';
import AccountModerationNotice from '@/components/accountmoderationnotice';

const { Content } = Layout;

const Info = () => {
  // 配置初始化
  const navigate = useNavigate();
  const goBack = usePageBack('/personal');
  const location = useLocation();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 480);
  // 个人信息
  const { isAuthenticated, userInfo } = useSelector(state => state.user);
  // 一键编辑弹窗
  const [allOpen, setAllOpen] = useState(false);
  // 修改昵称
  const [nicknameOpen, setNicknameOpen] = useState(false);
  // 修改头像
  const [avatarOpen, setAvatarOpen] = useState(false);
  // 修改性别
  const [genderOpen, setGenderOpen] = useState(false);
  const rows = [
    { key: 'school', label: '学校', value: userInfo?.school_name || '未选择', action: <SchoolEditor /> },
    {
      key: 'avatar',
      label: '头像',
      value: <Avatar size="large" src={userInfo?.avatar || undefined} icon={<UserOutlined />} />,
      action: <Button type="link" onClick={() => setAvatarOpen(true)}>修改头像</Button>,
    },
    {
      key: 'username',
      label: '用户名',
      value: userInfo?.username || '未设置',
    },
    {
      key: 'nickname',
      label: '昵称',
      value: userInfo?.nickname || '未设置',
      action: <Button type="link" onClick={() => setNicknameOpen(true)}>修改昵称</Button>,
    },
    {
      key: 'gender',
      label: '性别',
      value: userInfo?.gender === 'M' ? '男' : userInfo?.gender === 'F' ? '女' : '未设置',
      action: <Button type="link" onClick={() => setGenderOpen(true)}>修改性别</Button>,
    },
    {
      key: 'email',
      label: '邮箱',
      value: userInfo?.email || '未设置',
      action: <Link to="/personal/email">{userInfo?.is_email_verified ? '邮箱设置' : '未验证 · 邮箱设置'}</Link>,
    },
    {
      key: 'password',
      label: '密码',
      value: '********',
      action: <Button type="link" onClick={() => navigate('/personal/modify')}>修改密码</Button>,
    },
    {
      key: 'uid',
      label: 'UID',
      value: userInfo?.id ?? '未设置',
    },
  ];
  // // 监听屏幕宽度变化，响应式切换页面布局
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 480);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  // 用户没登录就访问的话提示用户并跳转到登录页
  if (!isAuthenticated && location.pathname === '/personal/info') {
    message.warning('请登录后再访问该页面');
    return <Navigate to="/login" replace />;
  }

  return (
    <div className='info'>
      {/* 移动端显示返回按钮 */}
      {isMobile ?
        <PageTopbar className="info-mobile-topbar" title="个人资料" onBack={goBack} /> : null}
      {/* 内容区域 */}
      <Content>
        <section className="info-panel" aria-labelledby="info-panel-title">
          <div className="info-panel-heading">
            <div><h1 id="info-panel-title">个人资料</h1><p>管理你的学校、个人信息与账号设置</p></div>
            <Button type="primary" onClick={() => setAllOpen(true)}>一键编辑</Button>
          </div>
          <AccountModerationNotice />
          <dl className="info-details">
            {rows.map(({ key, label, value, action }) => (
              <div className={`info-row info-row-${key}`} key={key}>
                <dt>{label}</dt>
                <dd>
                  <span className="info-value" title={key === 'email' ? value : undefined}>{value}</span>
                  {action}
                </dd>
              </div>
            ))}
          </dl>
        </section>
      </Content>
      {/* 一键编辑弹窗 */}
      <EditAllModal allOpen={allOpen} setAllOpen={setAllOpen} />
      {/* 修改昵称弹窗 */}
      <EditNicknameModal nicknameOpen={nicknameOpen} setNicknameOpen={setNicknameOpen} />
      {/* 修改头像弹窗 */}
      <EditAvatarModal avatarOpen={avatarOpen} setAvatarOpen={setAvatarOpen} />
      {/* 修改性别弹窗 */}
      <EditGenderModal genderOpen={genderOpen} setGenderOpen={setGenderOpen} />
    </div>
  );
};

export default Info;
